import * as React from "react";
const ErrorRetryIcon = (props) => (
  <svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25 4C36.598 4 46 13.402 46 25C46 36.598 36.598 46 25 46C13.402 46 4 36.598 4 25C4 13.402 13.402 4 25 4ZM22.5703 11.8066L14.4736 12.665C13.6852 12.7487 13.3028 13.6729 13.8018 14.2891L15.3877 16.248C13.7221 18.0773 12.6082 20.3497 12.1875 22.8018C11.7099 25.5862 12.1517 28.4513 13.4473 30.9619C14.7428 33.4724 16.8211 35.4928 19.3672 36.7168C21.9132 37.9408 24.7889 38.3021 27.5586 37.7461C30.3285 37.19 32.8424 35.7458 34.7188 33.6338C36.5949 31.5218 37.7319 28.856 37.958 26.04C38.184 23.224 37.487 20.4106 35.9717 18.0264C34.4563 15.6422 32.2051 13.817 29.5596 12.8262L28.127 16.6504C29.9415 17.33 31.486 18.5815 32.5254 20.2168C33.5648 21.8522 34.0428 23.7824 33.8877 25.7139C33.7326 27.6451 32.9528 29.4734 31.666 30.9219C30.379 32.3705 28.6547 33.3608 26.7549 33.7422C24.8552 34.1235 22.883 33.8756 21.1367 33.0361C19.3903 32.1966 17.9648 30.8108 17.0762 29.0889C16.1876 27.3669 15.8843 25.402 16.2119 23.4922C16.4649 22.018 17.0837 20.6387 18.002 19.4756L19.375 21.1709C19.8739 21.787 20.8568 21.6053 21.1025 20.8516L23.626 13.1104C23.8505 12.4213 23.2909 11.7303 22.5703 11.8066Z"
      fill="#CB1D49"
    />
  </svg>
);
export default ErrorRetryIcon;
